// extracted by mini-css-extract-plugin
module.exports = {"gridArea":"managerMngt_gridArea__2kStB"};